import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { select } from '@ngxs/store';
import { AccountState } from '@shared/states/account.state';

@Component({
  selector: 'brand-email',
  templateUrl: './brand-email.component.html',
  styleUrls: ['./brand-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BrandEmail {
  @Input()
  @HostBinding('class')
  class: string;

  @Input()
  address: string;

  readonly parentBranding = select(AccountState.parentBranding);
}
